/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_ProcessingInputs */

const en_agent_authorization_processing = /** @type {(inputs: Agent_Authorization_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving decision...`)
};

const zh_agent_authorization_processing = /** @type {(inputs: Agent_Authorization_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在保存决定...`)
};

/**
* | output |
* | --- |
* | "Saving decision..." |
*
* @param {Agent_Authorization_ProcessingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_processing = /** @type {((inputs?: Agent_Authorization_ProcessingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_ProcessingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_processing(inputs)
	return zh_agent_authorization_processing(inputs)
});
export { agent_authorization_processing as "agent.authorization.processing" }